import type { PayRunCardDto } from './payRunsApiTypes';

const currency = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' });
const date = new Intl.DateTimeFormat('en-AU', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' });

export const formatSystemValue = (value: string): string => {
  const words = value.replace(/_/g, ' ');
  return words ? `${words[0].toUpperCase()}${words.slice(1)}` : '';
};

export const formatPayRunDate = (value: string): string => {
  const parsed = new Date(`${value}T00:00:00Z`);
  return Number.isNaN(parsed.getTime()) ? value : date.format(parsed);
};

const calculation = (value: number): string => currency.format(value);

export const buildPayRunCardModel = (card: PayRunCardDto) => ({
  id: card.payId,
  title: card.displayTitle,
  businessRecordName: card.businessRecordName,
  payGroupName: card.payGroupName,
  frequencyValue: card.frequency,
  frequencyLabel: formatSystemValue(card.frequency),
  periodLabel: card.payPeriodLabel,
  periodRange: `${formatPayRunDate(card.periodStartDate)} – ${formatPayRunDate(card.periodEndDate)}`,
  paymentDate: formatPayRunDate(card.paymentDate),
  runTypeValue: card.runType,
  runTypeLabel: formatSystemValue(card.runType),
  operatingStateValue: card.operatingState,
  operatingStateLabel: formatSystemValue(card.operatingState),
  workflowStatusValue: card.workflowStatus,
  workflowStatusLabel: formatSystemValue(card.workflowStatus),
  facets: card.statusFacets.map((facet) => ({
    type: facet.type,
    value: facet.status,
    label: `${formatSystemValue(facet.type)}: ${formatSystemValue(facet.status)}`,
    detail: facet.detail,
    blockingCount: facet.blockingCount ?? 0,
    warningCount: facet.warningCount ?? 0,
  })),
  gross: calculation(card.gross),
  tax: calculation(card.tax),
  super: calculation(card.super),
  netPay: calculation(card.netPay),
  employeeCount: card.employeeCount,
  actions: card.meta.actions,
});
